"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationState;
(function (ValidationState) {
    ValidationState[ValidationState["valid"] = 0] = "valid";
    ValidationState[ValidationState["warning"] = 1] = "warning";
    ValidationState[ValidationState["invalid"] = 2] = "invalid";
})(ValidationState = exports.ValidationState || (exports.ValidationState = {}));
//# sourceMappingURL=BasePicker.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/pickers/BasePicker.types.js
// module id = 274
// module chunks = 0